var placeholderInit = function () {
    if (!Modernizr.input.placeholder) {

        $('[placeholder]').each(function () {

            var $input = $(this);
            var placeholder = 'placeholder';

            if (!$input.val()) {
                $input
                    .val($input.attr(placeholder))
                    .addClass(placeholder);
            }

            $input
                .on('focus', function () {
                    if ($input.val() == $input.attr(placeholder)) $input.val('').removeClass(placeholder);
                })
                .on('blur', function () {
                    if ($input.val() == '' || ($input.val() == $input.attr(placeholder))) $input.val($input.attr(placeholder)).addClass(placeholder);
                });
        });
    }
}
